import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Clock, BookOpen, ArrowRight } from 'lucide-react';

const BuildingCard = ({ building, rooms, available, totalClasses }) => {
  const navigate = useNavigate();
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="group cursor-pointer flex flex-col gap-3"
      onClick={() => navigate(`/building/${encodeURIComponent(building)}`)}
    >
      {/* Image Container */}
      <div className="relative aspect-video rounded-2xl overflow-hidden bg-white/5">
        <img
          src={`/buildings/${building.toLowerCase().replace(/\s+/g, '-')}.jpg`}
          alt={building}
          onLoad={() => setImageLoaded(true)}
          className={`w-full h-full object-cover transition-all duration-500 group-hover:scale-105 ${
            imageLoaded ? 'opacity-100' : 'opacity-0'
          }`}
        />
        
        {/* Availability Badge */}
        <div className="absolute top-3 right-3">
          <div className={`
            px-3 py-1.5 rounded-full backdrop-blur-md text-xs font-semibold flex items-center gap-1.5 shadow-lg
            ${available > 0 
              ? 'bg-green-500/90 text-white' 
              : 'bg-red-500/90 text-white'}
          `}>
            <div className={`w-1.5 h-1.5 rounded-full bg-white ${available > 0 ? 'animate-pulse' : ''}`} />
            {available} Available
          </div>
        </div>

        {/* Overlay gradient */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-60" />
      </div>

      {/* Content */}
      <div className="px-1">
        <div className="flex justify-between items-start mb-2">
          <h3 className="text-xl font-bold text-white group-hover:text-purple-400 transition-colors">
            {building}
          </h3>
          <ArrowRight className="w-5 h-5 text-gray-500 group-hover:text-purple-400 transition-colors -rotate-45 group-hover:rotate-0 transform duration-300" />
        </div>

        <div className="flex items-center gap-4 text-sm text-gray-400">
          <div className="flex items-center gap-1.5">
            <BookOpen className="w-4 h-4" />
            <span>{rooms.length} Rooms</span>
          </div>
          <div className="flex items-center gap-1.5">
            <Clock className="w-4 h-4" />
            <span>{totalClasses} Classes Today</span>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default BuildingCard;